import Ripple from 'vue-ripple-directive'
import {
  required, size, numeric, max, length, ibanValidate,
} from '@validations'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import jalaali from 'moment-jalaali'
import DatePicker from 'vue-persian-datetime-picker'
import { alphanumeric } from '@/mixins/alphanumeric'
import showErrorMessages from '@/mixins/showErrorMessages'
import checkFileSize from '@/mixins/checkFileSize'
import BankApis from '@/services/apis/documents/bank'
import ProfileApis from '@/services/apis/profile'
import FormApis from '@/services/apis/form'
import { resizeImage, toEnglishDigits } from '@/utils'
import moment from '@/libs/moment'
import CurrencyApis from '@/services/apis/currency'

const currency = new CurrencyApis()
const formData = new FormApis()
const profile = new ProfileApis()
const bank = new BankApis()
export default {
  components: {
    vSelect,
    DatePicker,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric, showErrorMessages, checkFileSize],
  data() {
    return {
      card_number: '',
      currency: '',
      currencies: [],
      file_back: null,
      iban: '',
      required,
      size,
      numeric,
      max,
      length,
      ibanValidate,
      pending: false,
      expiration_date: '',
      banks: [],
      show: false,
      isHidden: true,
      countries: [],
      country: '',
      isPreparingFiles: false,
      currentUpload: 0,
      uploadSize: 0,
    }
  },
  computed: {
    ...mapGetters(['getCitizenship']),
    convertedExpiration() {
      return jalaali(this.expiration_date, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
    },

    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
    isCryptoMode() {
      return process.env.VUE_APP_ACTIVE_MODULES.includes('CRYPTO')
    },
  },
  watch: {
    '$store.state.Messaging.event': {
      async handler(newVal) {
        if (newVal === 'document_bank') {
          await this.getData()
          this.$store.dispatch('Messaging/setEvent', '')
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.show = true
    formData.countryLists().then(res => {
      const result = res.data.results
      this.countries = result.map(item => ({
        id: item.id,
        name: item.name,
        // eslint-disable-next-line global-require, import/no-dynamic-require
        image: require(`@/assets/images/flags/${item.abbreviation}.png`),
      }))
    }).finally(() => {
      this.show = false
    })
  },

  async created() {
    await this.getData()
    await this.getCurrency()
    this.show = false
  },

  methods: {
    convertIBAN2Uppercase(event) {
      this.iban = event.toUpperCase()
    },
    async getCurrency() {
      await currency.currencies().then(res => {
        // eslint-disable-next-line prefer-destructuring
        this.currencies = res.data.results.filter(item => !item.document_hide).map(item => ({
          fullLable: `${item.name} (${item.currency} - ${item.symbol})`,
          ...item,
        }))
        if (res.data.results.form[0]) {
          // eslint-disable-next-line prefer-destructuring
          this.currency = res.data.results.form[0]
        }
      }).catch(err => {
        console.log(err)
      })
    },
    async getData() {
      this.show = true
      await bank.getDataInfo().then(res => {
        // eslint-disable-next-line prefer-destructuring
        this.banks = res.data.results
      }).finally(() => {
        this.show = false
      })
    },
    async submit() {
      if (moment().diff(moment(this.convertedExpiration).format('YYYY-MM-DD'), 'days') >= 1) {
        await this.$refs.expiration_date_ref.applyResult({
          errors: [this.$t('this_card_is_expire')], // array of string errors
          valid: false, // boolean state
          failedRules: {}, // should be empty since this is a manual error.
        })
        return
      }
      if (await this.$refs.bankTab.validate()) {
        const imageSize = (process.env.VUE_APP_RESIZE_IMAGE_SIZE ? process.env.VUE_APP_RESIZE_IMAGE_SIZE : 3072) * 1024
        this.isPreparingFiles = true
        this.pending = true
        const data = {
          numbers: toEnglishDigits(this.card_number),
          file_proof: await resizeImage(this.file_back, imageSize),
          iban: toEnglishDigits(this.iban),
          expiration_date: this.convertedExpiration,
          currency_id: this.currency.id,
          country_id: this.country.id,
        }
        this.isPreparingFiles = false
        await bank.SaveBankInfo(data, e => {
          this.uploadSize = e.total
          this.currentUpload = e.loaded
        }).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.getData()
          profile.get()
        }).finally(() => {
          this.pending = false
          this.uploadSize = 0
          this.currentUpload = 0
          this.isPreparingFiles = false
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        })
      }
    },
  },

  baseUrl() {
    return process.env.VUE_APP_BASE_IMAGE_URL
  },

}
